/**
 * Behaviours (`/behaviours`) — what visitors actually do once they
 * land. Scaffold today; the underlying data shape (`pixel_top_events`
 * + the raw `event_kind` / `event_name` columns on
 * `pixel_events_*`) is already flowing, just not surfaced.
 *
 * Eventual shape:
 *   - Click map / top-clicked elements (uses pixel_attribution
 *     `target_value` rows where target_kind = 'click_target').
 *   - Outbound link summary (event_kind = 'outbound_click').
 *   - Custom-event funnel (event_kind = 'custom' + event_name).
 *   - Scroll-depth distribution per page (scroll_depth_pct column).
 *   - Engagement / time-on-page distribution (active_visible_ms).
 *
 * Sits as a peer of Traffic and Performance so the IA reads as three
 * different lenses on the same beacon stream: who, how fast, what.
 */
import { EmptyState } from '@/components/primitives/EmptyState';
import { SiteIsland } from '@/components/shell/SiteIsland';
import { Cursor } from '@phosphor-icons/react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import type { ReactElement } from 'react';

export const Route = createFileRoute('/_app/behaviours/')({
  // Disabled surface — redirect any direct access to /performance.
  beforeLoad: () => {
    throw redirect({ to: '/performance' });
  },
  component: BehavioursPage,
});

function BehavioursPage(): ReactElement {
  return (
    <SiteIsland section="Behaviours">
      <div className="space-y-6">
        <EmptyState
          icon={Cursor}
          title="Behaviours — coming soon"
          description="What visitors actually do once they land: clicks, scroll depth, outbound links, custom events, engagement time. The event pipeline is already capturing this; the surface lands after Performance."
        />
      </div>
    </SiteIsland>
  );
}
